import { render, staticRenderFns } from "./modal-profile.vue?vue&type=template&id=1e6da821&"
import script from "./modal-profile.vue?vue&type=script&lang=js&"
export * from "./modal-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports